import { getReferFriendEmailCookie } from '@wkda/funnel-utils';
export function referralCodeMapper() {
  const referralCode = getReferFriendEmailCookie();
  let payload = {};
  if (referralCode) {
    payload = {
      referralCode: referralCode
    };
  }
  return payload;
}